module.exports = __webpack_public_path__ + "media/images/icon-filter-f4bae5d6da75f427bb5c79ca55866526.png";